import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as FlowIcon } from '~app/resources/images/icons/flow-icon.svg';
import { ReactComponent as StockIcon } from '~app/resources/images/icons/stock-icon.svg';
import { ReactComponent as VariableIcon } from '~app/resources/images/icons/variable-icon.svg';
import { ReactComponent as ConnectorNegativeIcon } from '~app/resources/images/icons/negative-signal-icon.svg';
import { ReactComponent as ConnectorNeutralIcon } from '~app/resources/images/icons/neutral-signal-icon.svg';
import { ReactComponent as ConnectorPositiveIcon } from '~app/resources/images/icons/positive-signal-icon.svg';
import { ReactComponent as UnassignedIcon } from '~app/resources/images/icons/unassigned-icon.svg';

import useGlobalHotkey from '~app/core/useGlobalHotkey';
import withEnterToClick from '~app/core/withEnterToClick';

const ClickOrEnterDiv = withEnterToClick('div');

const getSvgComponent = symbol => {
  switch (symbol) {
    case 'FlowIcon':
      return <FlowIcon />;
    case 'StockIcon':
      return <StockIcon />;
    case 'VariableIcon':
      return <VariableIcon />;
    case 'UnassignedIcon':
      return <UnassignedIcon />;
    case 'ConnectorNegativeIcon':
      return <ConnectorNegativeIcon />;
    case 'ConnectorNeutralIcon':
      return <ConnectorNeutralIcon />;
    case 'ConnectorPositiveIcon':
      return <ConnectorPositiveIcon />;
    default:
      return null;
  }
};

const SideBarButton = ({
  onClick,
  children,
  disabled,
  ariaLabel,
  src,
  alt,
  hilited,
  hotkey,
  symbol,
}) => {
  const callback = useCallback(() => {
    if (!disabled) onClick();
  }, [disabled, onClick]);
  useGlobalHotkey({ hotkey, callback });
  const doctype = useSelector(state => state.document.present?.type);
  return !(symbol === 'ConnectorNeutralIcon' && doctype === 'stockflow') ? (
    <ClickOrEnterDiv
      className={classNames('SideBarButton__button', {
        'SideBarButton--disabled': disabled,
        hilited: hilited,
      })}
      role="button"
      tabIndex="0"
      onClick={onClick}
      disabled={disabled}
      aria-label={`${ariaLabel} ${hilited ? 'current' : ''}`}
      aria-disabled={disabled}
      aria-current={hilited}
    >
      {src && (
        <div className="SideBarButton__icon">
          <img src={src} alt={alt} />
        </div>
      )}
      {symbol && getSvgComponent(symbol)}
      <div className="SideBarButton__text">{children}</div>
    </ClickOrEnterDiv>
  ) : null;
};

SideBarButton.propTypes = {
  styleName: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

SideBarButton.defaultProps = {
  disabled: false,
};

export default SideBarButton;
